export class AuthError extends Error {
  constructor(public code: "forbidden" | "unauthorized" = "forbidden") {
    super(code);
    this.name = "AuthError";
  }
}
